<template lang="pug">
div(:style="{ height: `${height}px` }")
  canvas(ref="chart")
</template>

<script>
import Chart from 'chart.js/auto'

export default {
  name: 'ChartOrderTypes',

  props: {
    orderTypes: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      default: 300
    }
  },

  data: () => ({
    chart: null
  }),

  watch: {
    orderTypes: {
      handler() {
        this.renderChart()
      },
      deep: true
    }
  },

  methods: {
    getTypeLabel(type) {
      const labels = {
        'local': 'En Salón',
        'takeaway': 'Para Llevar',
        'delivery': 'Delivery',
        'rappi': 'Rappi',
        'pedidosya': 'PedidosYa'
      }
      return labels[type] || type
    },

    getBackgroundColors() {
      return [
        '#B39DDB',   // Morado (mismo que en Dashboard)
        '#F48FB1',   // Rosa
        '#EF9A9A',   // Rojo claro
        '#9FA8DA',   // Azul claro
        '#81C784',   // Verde claro
        '#FFE082'    // Amarillo claro
      ]
    },

    formatCurrency(value) {
      // Formatear como moneda en pesos argentinos
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 0
      }).format(value)
    },

    renderChart() {
      if (this.chart) {
        this.chart.destroy()
      }

      if (!this.orderTypes || !this.orderTypes.length) return

      // Log para depuración
      console.log('OrderTypes recibidos:', JSON.stringify(this.orderTypes, null, 2))

      const ctx = this.$refs.chart.getContext('2d')
      
      const labels = this.orderTypes.map(item => this.getTypeLabel(item.type))
      // Garantizar que los valores son números válidos
      const data = this.orderTypes.map(item => {
        const value = typeof item.total === 'number' ? item.total : 
                    typeof item.total === 'string' ? parseFloat(item.total) :
                    typeof item.count === 'number' ? item.count :
                    typeof item.count === 'string' ? parseFloat(item.count) : 0
        return isNaN(value) ? 0 : value
      })
      const backgroundColors = this.getBackgroundColors().slice(0, this.orderTypes.length)

      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: backgroundColors,
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom'
            },
            tooltip: {
              callbacks: {
                label: (tooltipItem) => {
                  const label = tooltipItem.label || ''
                  // Asegurar que estamos trabajando con un número
                  const rawValue = parseFloat(tooltipItem.raw) || 0
                  const value = this.formatCurrency(rawValue)
                  
                  // Calcular el total con seguridad
                  const total = tooltipItem.dataset.data.reduce((a, b) => {
                    return parseFloat(a) + (parseFloat(b) || 0)
                  }, 0);
                  
                  // Evitar división por cero
                  let percentage = 0;
                  if (total > 0) {
                    percentage = Math.round((rawValue / total) * 100);
                  }
                  
                  return `${label}: ${value} (${percentage}%)`
                }
              }
            }
          }
        }
      })
    }
  },

  mounted() {
    this.renderChart()
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
</script>
